export default __webpack_public_path__ + "static/media/lgb-loveletter-cover.d202233c.jpg";